<template>
  <div id="expert-documents">
    <template v-for="(documentSE, key) in documentsSE">
      <div class="row" :key="key" :class="(documentSE.title==='Publications' || documentSE.title==='Training' || documentSE.title==='Influence' )?'hide':''">
        <div class="col-xs-12 well">
          <div class="clearfix"></div>
          <div class="row" style="margin-top: 10px">
            <div class="col-md-2 col-xs-12 col-sm-3 item-label">
              <span v-html="documentSE.title"></span>
            </div>
            <div class="col-md-10 col-xs-12 col-sm-9 text-justify">
              <span v-html="abstractFormat(documentSE.abstract)"></span>
            </div>
          </div>
        </div>
      </div>

    </template>

    <document-author v-if="documents" v-model="documents" :author="author"
                     :pubDateSelected="pubDateSelected" :context="context"/>
  </div>
</template>

<style>
  .item-label {
    font-weight: bold;
  }
  .coAuthors-divider + .coAuthors-divider:before {
    content: ", ";
  }
  .selected {
    border-left: 5px solid #34495e;
  }

</style>
<script>

import DocumentAction from './DocumentAction'
import DocumentAuthor from './DocumentAuthor'
export default {
  name: 'DocumentSEAuthor',
  components: {DocumentAuthor, DocumentAction},
  props: ['value', 'author', 'context', 'pubDateSelected'],
  watch: {
    value: function (val) {
      this.sortDocuments(val)
    },
    documents: function (val, oldVal) {
      if (oldVal !== null) {
        //console.log('updates documents')
        // this.$emit('input', val)
      }
    },
    pubDateSelected: function (pubDateSelected) {
      let documents = this.author.docs
      if (pubDateSelected.length !== 0) {
        documents = documents.filter((document) => {
          let date = new Date(document.pubDate).getFullYear()
          let tmpYear = pubDateSelected.find((year) => {
            return date === year.name
          })
          return typeof tmpYear !== 'undefined'
        })
      }
      this.documents = documents
    }
  },
  methods: {
    sortDocuments (docs) {
      this.documents = []
      this.documentsSE = []

      let priorities = {
        'Primary Domain': 0,
        'Publications': 1,
        'Training': 2,
        'Influence': 3,
        'Edison Since': 4
      }

      docs.forEach((doc) => {
        if (typeof priorities[doc.title] !== 'undefined' || (typeof doc.sourceID !== 'undefined' && doc.sourceID === 12)) {
          this.documentsSE.push(doc)
        } else {
          this.documents.push(doc)
        }
      })

      this.documentsSE.sort((doc1, doc2) => {
        return (typeof priorities[doc1.title] !== 'undefined' && typeof priorities[doc2.title] !== 'undefined')
          ? priorities[doc1.title] > priorities[doc2.title] : new Date(doc2.pubDate) - new Date(doc1.pubDate)
      })

      this.documents.sort((doc1, doc2) => {
        return new Date(doc2.pubDate) - new Date(doc1.pubDate)
      })
    },
    abstractFormat: function (abstract) {
      return abstract.replace('No Publications. Detailed field of expertise :', 'No Publications.<br><br><u>Detailed field of expertise :</u><br>')
    }
  },
  data () {
    return {
      documents: null,
      documentsSE: null
    }
  },
  beforeMount () {
    this.sortDocuments(this.value)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/DocumentSEAuthor.vue